"use client"

import Script from "next/script";

export default function Apollo() {
    const n = Math.random().toString(36).substring(7);

    return  <Script 
                src={"https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache=" + n}
                async
                defer
                strategy="lazyOnload"
                onLoad={() => {
                    window.trackingFunctions.onLoad({appId:"673b2ac9cee2de01b1d24a88"})
                }}
            />
}
